import dayjs from 'dayjs'
import { useState } from 'react'
import { tabelaHorarios } from 'service/api'
import { useStore } from 'store'
import CalendarioTabelasHorario from './Calendario/CalendarioTabelasHorario'

export default function TabCalendario({ editable = true }) {
    const funcionarioId = useStore(state => state.employeeId)
    const [competencia, setCompetencia] = useState(() =>
        dayjs().format('YYYY-MM'),
    )

    const competenciaDayjs = dayjs(competencia, 'YYYY-MM')
    const { data = [] } = tabelaHorarios.funcionario.useFetch({
        queryParams: {
            funcionarioId,
            dataInicial: competenciaDayjs
                .startOf('month')
                .subtract(2, 'week')
                .format('YYYY-MM-DD'),
            dataFinal: competenciaDayjs
                .endOf('month')
                .add(2, 'week')
                .format('YYYY-MM-DD'),
        },
    })

    return (
        <CalendarioTabelasHorario
            value={competencia}
            tabelas={data}
            onChange={setCompetencia}
            editable={editable}
        />
    )
}
